// extracted by mini-css-extract-plugin
export var formContainer = "_f7-0";
export var message = "_f7-1";